import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  props: {
    header: { default: '' },
    text: { default: '' },
    backgroundStyle: { default: '' },
    type: { default: 'dark' }
  },
  setup(__props: any) {

//This is a DS component, it will be moved to DS repo
//TODO Move component to DS repo for use


return { __sfc: true, }
}

})